export const GET_ROLE = 'providers/workforce/RoleDetails/GET_ROLE';

export const SAVE_ROLE = 'providers/workforce/RoleDetails/SAVE_ROLE';
